import React, { useState, useEffect } from 'react';
import { Button, FormGroup, Input, Label } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

const SelectAccountType = ({ nextStep, active, prevStep, processing, investAccount }) => {
    const [accountType, setAccountType] = useState('standard');
    const [accountFor, setAccountFor] = useState('');

    useEffect(() => {
        if (active && investAccount && investAccount.id) {
            setAccountFor(investAccount.ownership);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, investAccount]);

    const handleSubmit = () => {
        if (!accountType || !accountFor) {
            toast.error('Please select account type');
            return;
        }
        toast.dismiss();
        nextStep({ purpose: accountType, ownership: accountFor });
    };

    const handleBack = () => {
        prevStep();
    }

    return (
        <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
            <div className="form-container">
                <div className="back-btn">
                    <Button color="link" onClick={handleBack}>back</Button>
                </div>
                <div className="form-header mt-md-3 mt-0">
                    <h2>OPEN A NEW ACCOUNT</h2>
                    <span>What type of account would you like to open?</span>
                </div>
                <div className="account-info-container d-flex">
                    <div className="account-type">
                        <button className={`btn ${accountType === 'standard' ? 'btn-primary' : 'btn-outline-secondary'}`}
                            onClick={() => setAccountType('standard')}>
                            Standard <FontAwesomeIcon icon={faQuestionCircle} />
                        </button>
                        <button className="btn btn-outline-secondary" disabled={true}>
                            Retirement <FontAwesomeIcon icon={faQuestionCircle} />
                        </button>
                        <button className="btn btn-outline-secondary" disabled={true}>
                            College Savings <FontAwesomeIcon icon={faQuestionCircle} />
                        </button>
                    </div>
                    <div className="account-for">
                        <FormGroup check>
                            <Label check>
                                <Input
                                    type="radio"
                                    name="account-for"
                                    checked={accountFor === 'individual' ? true : false}
                                    onChange={() => setAccountFor('individual')} />
                                <span className="account-for-title">Individual</span>
                                <br />For individuals. Invest for your goals.
                            </Label>
                        </FormGroup>
                        <FormGroup check disabled>
                            <Label check>
                                <Input type="radio"
                                    name="account-for"
                                    checked={accountFor === 'joint' ? true : false}
                                    onChange={() => setAccountFor('joint')} />
                                <span className="account-for-title">Joint</span>
                                <br />For partners. Invest for your goals.
                            </Label>
                        </FormGroup>
                        <FormGroup check disabled>
                            <Label check>
                                <Input type="radio" name="account-for" disabled />
                                <span className="account-for-title">
                                    Trust<span className="ml-3 text-danger">Coming soon!</span>
                                </span>
                                <br />For a trust. Invest for your goals.
                            </Label>
                        </FormGroup>
                    </div>
                </div>
                <div className="button_wrapper">
                    <button className="custom-btn-primary" type="button" onClick={() => handleSubmit()} disabled={processing}>
                        OPEN THIS ACCOUNT {processing && <FontAwesomeIcon icon={faSpinner} spin />}
                    </button>
                </div>
                <div className="links-forgot">
                    <a href="#/">Help me choose which account to open</a>
                </div>
            </div>
        </div>
    )
};

export default SelectAccountType;
